import React, {useEffect} from "react";
import {connect, useSelector} from "react-redux";


// components
import DestinationList from "./_list";
import {showLoader} from "../../../components/loader/loader";


// actions
import {
    ADD_STATE,
    REMOVE_STATE,
    setUdn,
    setApp,
    setUserIsAdmin
} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";


import '../../../assets/css/DragAndDrop.css';


const Destination = (props) => {
    const path = '/xailing/destination';
    const componentState = useSelector(state => getStateByPath(state, path));
    const {loading} = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        const _udn = localStorage.getItem('selectedUdn') !== '' ? JSON.parse(localStorage.getItem('selectedUdn')) : null

        if (_udn !== null)
            props.setUdn(path, _udn);

        if (props.app !== null)
            props.setApp(path, props.app);
    },[]);


    return <>
        {loading && showLoader()}
        { componentState && <DestinationList path={path} /> }
    </>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setUdn,
    setApp,
    setUserIsAdmin,
})

export default connect(mapStateToProps, mapActionsToProps)(Destination);